module.exports = __webpack_public_path__ + "banquet/components/StoreAboutPage/images/about_clock_3x.e4e22aca6c575e88c01dd23f62ce8dc0.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/StoreAboutPage/images/about_clock_3x.png
// module id = 1691
// module chunks = 1